import React, { useState, useEffect  } from "react";
import L from "leaflet";
import {  Button,notification,message} from "antd";
import { InboxOutlined ,SaveOutlined,CloseCircleFilled,DeleteOutlined,HighlightOutlined,ArrowRightOutlined} from "@ant-design/icons";

import {
  MapContainer,  
  useMapEvent,
  TileLayer,
  Polygon ,
  Marker,
  
  Popup
} from "react-leaflet";
   
import "./MapPoly.scss";
import "leaflet/dist/leaflet.css";

import { get } from "../../../api/get";
import { getAccessTokenApi,getRefreshTokenApi,getPublicIP } from "../../../api/auth";
import {getContarError} from "../../../api/user";
import { basePath, apiVersion ,ip} from "../../../api/config";
 
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

export default function MapPoly(props) {
  const {nombre,isInput}=props;
  const [polygonCoords, setPolygonCoords] = useState([]);
  const [puntos, setpuntos] = useState([]);
  const [puntos_, setpuntos_] = useState([]);
  const [isAllowed, setisAllowed] = useState(false);
  const [circular, setCircular] = useState(false);
  var punto = [];

  useEffect( () =>  { 
    const token = getAccessTokenApi();
    var DATA ;
    // console.log(nombre)
    var name=String(nombre).split('.')[0]
    get('getExcelRawInput','getExcelRawInput',`/${name}` ).then((response) => {
    // getExcelFromIDInput(token, name).then((response) => {
       DATA = response.DATA;
      // console.log('Data: ',DATA);

      var puntos2 = [];
      DATA.IN1_Orders.map(function (x) {
        if(x.order_mode==='shipment'){
          puntos2.push({
            order_id:x.order_id+'s',
            punto1: [parseFloat(x.order_lat1), parseFloat(x.order_lon1)],
          });
          puntos2.push({
            order_id:x.order_id+'f',
            punto1: [parseFloat(x.order_lat2), parseFloat(x.order_lon2)],
          });
        }else{
          puntos2.push({
            order_id:x.order_id,
            punto1: [parseFloat(x.order_lat1), parseFloat(x.order_lon1)],
          });}

      });
      setpuntos_(puntos2);
      for (let i = 0; i < puntos2.length; i++) {
       
          punto.push(
            <Marker 
            icon={L.divIcon({
           
              html: `<div class="marker-capillar">
                 <div class="green-circle" >
                 </div>
                 <div class="number" >
                     ${puntos2[i].order_id}
                 </div>
               </div>`,
            })}
            position={puntos2[i].punto1}>
              <Popup className="popUpMarcador" closeButton={true}>
             <div className="popUpMarcador-top">
              ID: {puntos2[i].order_id} 
              </div>
              
              </Popup>
            </Marker>
          );
       
      }
      setpuntos(punto);

      })
    }, []);

  async function  simularPuntos(vector){
    var status;
    var urlFetch='';
    var messag=''; 
    var url= `${basePath}/${apiVersion}/simulate-all-points`;


    var datos = {
      vector:vector,
      name:nombre
    }


    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
         Authorization: "Bearer " + getAccessTokenApi(),
        refreshToken: "Bearer " + getRefreshTokenApi(),
        functionname:'simularPuntos',
        ippublica:getPublicIP()
      },
      body: JSON.stringify(datos),
    };

    return await fetch(url, params)
    .then((response) => {
      status=response.status;
      urlFetch=response.url;
      urlFetch=urlFetch.replace(`https://${ip}:3004/`,'')
      return response.json();
    })
    .then((result) => {
      if(status!==200){
        messag=result.message
        notification["error"]({
          message: `Error ${status} in function: ${urlFetch}`,
          description:messag
        });
        getContarError(urlFetch,messag);
      }else{
        notification["success"]({
          message: `Changes saved!`,
          description:'Click "next" to continue.'
        });
      }
      return result;
    })
    .catch((err) => {
      return err.message;
    });
  }

  function MovingMarker() {
    const map = useMapEvent('click', (e) => {
    //  console.log("click",e.latlng.lat)
    //  console.log("click",e.latlng.lng)
    setPolygonCoords([...polygonCoords,[e.latlng.lat,e.latlng.lng]])
  })
  // console.log("polygonCoords",polygonCoords)

    return null
  }

  function sumInteriorAngles(points) {
    const n = points.length;
    let sum = 0;
    for (let i = 0; i < n; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % n];
      const p3 = points[(i + 2) % n];
      const angle = getAngle(p1, p2, p3);
      sum += angle;
    }
    return sum;
  }
  
  function getAngle(p1, p2, p3) {
    const v1 = { x: p1[0] - p2[0], y: p1[1] - p2[1] };
    const v2 = { x: p3[0] - p2[0], y: p3[1] - p2[1] };
    const dotProduct = v1.x * v2.x + v1.y * v2.y;
    const crossProduct = v1.x * v2.y - v1.y * v2.x;
    return Math.atan2(crossProduct, dotProduct) * 180 / Math.PI;
  }
  
  function isPolygon(points) {
    const sum = sumInteriorAngles(points);
    const interiorAngleSum = (points.length - 2) * 180;
    return Math.abs(sum - interiorAngleSum) < 1e-6;
  }

  function pointInPolygon(point, polygon) {
    let x = point.punto1[0];
    let y = point.punto1[1];
    let n = polygon.length;
    let inside = false;
    let p1x = polygon[0][0];
    let p1y = polygon[0][1];
    for (let i = 1; i <= n; i++) {
      let p2x = polygon[i % n][0];
      let p2y = polygon[i % n][1];
      if (y > Math.min(p1y, p2y)) {
        if (y <= Math.max(p1y, p2y)) {
          if (x <= Math.max(p1x, p2x)) {
            if (p1y !== p2y) {
              let xints = (y - p1y) * (p2x - p1x) / (p2y - p1y) + p1x;
              if (p1x === p2x || x <= xints) {
                inside = !inside;
              }
            }
          }
        }
      }
      p1x = p2x;
      p1y = p2y;
    }
    // console.log(inside)
    return inside;
  }
  // console.log(puntos[0])
  // console.log(puntos[0].props.position,'ahi va')
  return (
    (puntos.length>1)
    ?<>
     
      <div className="mapaColumn">
        <MapContainer
          className="leaflet-container"
          center={puntos[0].props.position}
          zoom={12}
        >
          
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {(isAllowed)&&<MovingMarker />}
          {polygonCoords.length > 0 && (
            <Polygon color="purple" positions={polygonCoords} />
          )} 
           {puntos}
        </MapContainer>
        {/* <div style={{ border: "10px solid black" }} ref={pluginRef} /> */}
        <div className="botones-mapa">
       
          <Button className="boton"
            type="primary"
            style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }}
            onClick={() => {
              setisAllowed(!isAllowed)}}>
              {(isAllowed)
              ?<CloseCircleFilled />
              :<HighlightOutlined />
              }
             { (isAllowed)
              ?'Disable draw in the map'
              :'Enable draw in the map'}
          </Button>
          <Button className="boton"
            type="primary"
            style={(isAllowed)
              ?{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                color:'rgb(0,104,178)',
                fontSize:'18px',
                backgroundColor: "white" }
              :{
                backgroundColor:'rgb(220,220,220)',
                borderWidth:'2px',
                fontSize:'15px',
                borderColor:'#737373',
                fontFamily: 'report-bold'
              }}
            disabled={(isAllowed)?false:true}
            onClick={() => {
              setPolygonCoords([])}}>
              <DeleteOutlined />
            Delete polygon
            
          </Button>
          <Button className="boton"
           style={{borderColor: "rgb(35,148,212)", 
           borderWidth:'2px',
           fontFamily:'report',
           color:'rgb(0,104,178)',
           fontSize:'18px',
           backgroundColor: "white" }}
            type="primary"
            onClick={async () => {
              var vector =[]
              var isInside=true
              var isOkey=true
              for (var i = 0; i < puntos.length;i++){
                if(String(puntos_[i].order_id).substring(1,2)==='s'){
                  isInside=pointInPolygon(puntos_[i],polygonCoords)
                  vector=[...vector,(isInside)?1:0]
                }else if(String(puntos_[i].order_id).substring(1,2)==='f'){
                  var isError=isInside
                  isInside=pointInPolygon(puntos_[i],polygonCoords)
                  if((!isError&&isInside) ||(isError&&!isInside) ){
                    message.error('Shipments order must be together, you cannot delete only one order of the shipment.');
                    isOkey=false
                    break;
                  }
                }else{
                  isInside=pointInPolygon(puntos_[i],polygonCoords)
                  vector=[...vector,(isInside)?1:0]
                }
              }
              console.log(vector)
              if(isOkey){
                setCircular(true)
                await simularPuntos(vector)
                setCircular(false)
                if(isInput==true){
                  window.location.href = "/admin/graphINPUTS?id="+nombre;
                }

              }
            }}
              >
            Save Changes
            
            <SaveOutlined />
          </Button>
        </div>
        {
        (circular)
        ?<div style={{display:'flex',justifyContent:'center'}}>
            <div>
            </div>
            <div className="cargandos">
            </div>
            <div>
            </div>
          </div>
        :<div className="vacio">
          </div>
        }
        
      </div>
    </>
    :<div className="cargand">
      <h2>Loading ...</h2>
      <div className="cargando">
      
    </div>
    </div>
  );
}

                
       